// ADDED: Payroll Reason Code Module
import React, { useState } from "react";
import PayrollReasonCodeTable from "./components/PayrollReasonCodeTable";
import PayrollReasonCodeAddEditModal from "./components/PayrollReasonCodeAddEditModal";
import { SearchBar, Button } from "../../../../common/APICommon";
import AddIcon from '@mui/icons-material/Add';

const PayrollReasonCodeModule = ({
  user,
  data,
  loading,
  searchData,
  getReasonCodeById,
  createReasonCode,
  updateReasonCode
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  // MODIFIED: Asynchronous handleEdit to fetch by ID first
  const handleEdit = async (item) => {
    const res = await getReasonCodeById(item.id);
    if (res.success) {
      setSelectedItem(res.data);
      setIsModalOpen(true);
    }
  };

  const handleSearch = (value) => {
    setCurrentPage(1);
    searchData(value);
  };

  const handleSave = async (form) => {
    const apiData = {
      ...form,
      description: form.description?.trim()
    };

     if (selectedItem) {
      // MODIFIED: Including additional fields in audit logs if they changed
      const audit = [{
        setupArea: "Payroll Reason Code",
        actionTaken: "update",
        field: "Details",
        newValue: `Desc: ${form.description}, Code: ${form.payrollCode}`, // MODIFIED
        oldValue: `Desc: ${selectedItem.description}, Code: ${selectedItem.payrollCode}`, // MODIFIED
        dateSaved: new Date(),
        savedById: user.id
      }];

      const res = await updateReasonCode(selectedItem.id, apiData, audit);
      if (res.success) setIsModalOpen(false);
    } else {
      const audit = {
        setupArea: "Payroll Reason Code",
        actionTaken: "insert",
        field: "Add",
        newValue: `New reason code: ${form.description}`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      };
      const res = await createReasonCode(apiData, audit);
      if (res.success) setIsModalOpen(false);
    }
  };

  return (
    <div className='p-4 space-y-4 relative'>
      <div className="flex justify-between items-center">
        <SearchBar handleFilter={handleSearch} />
        <Button
          icon={<AddIcon />}
          name={"Add Reason Code"}
          className={"bg-customGreen hover:bg-customGreenHover border-none cursor-pointer"}
          onClick={() => { setSelectedItem(null); setIsModalOpen(true); }}
        />
      </div>

      <PayrollReasonCodeTable
        data={data}
        onEdit={handleEdit}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />

      <PayrollReasonCodeAddEditModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedItem={selectedItem}
        onSave={handleSave}
      />
    </div>
  );
};

export default PayrollReasonCodeModule;